"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterWrapper = void 0;
var RouterWrapper_1 = require("./RouterWrapper");
Object.defineProperty(exports, "RouterWrapper", { enumerable: true, get: function () { return RouterWrapper_1.RouterWrapper; } });
//# sourceMappingURL=index.js.map